import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import style from './Faq.module.scss';
import MainButton from '../common/buttons/MainButton';
import { buttonVariants } from '../common/buttons/types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import styles from './Faq.module.scss';
import { FaqTypes } from '../../utils/constants';
import colors from '../../scss/colors';

export function Faq({ selectedData = [], onSelect }) {

    const [activeFaq, setActiveFaq] = useState(FaqTypes.ACCOUNTS);
    const [expandedAccordion, setExpandedAccordion] = useState(null);
    const { t } = useTranslation();

    const handleFaqTypeClick = (type) => {
        onSelect(type);
        setActiveFaq(type);
        setExpandedAccordion(null);
    };

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedAccordion(isExpanded ? panel : null);
    };

    return (
        <div className={style.faqContainer}>
            <div className={style.faqWrapper}>
                <h2>{t("landingPages.faq.title")}</h2>
                <div className={style.buttonContainer}>
                    <MainButton
                        variant={activeFaq === FaqTypes.ACCOUNTS ? buttonVariants.LIGHT_BLUE : buttonVariants.TEXT}
                        rounded={true}
                        size='xmedium'
                        action={() => handleFaqTypeClick(FaqTypes.ACCOUNTS)}
                        sx={{
                            textShadow: activeFaq === FaqTypes.ACCOUNTS ? '0 1px 2px rgba(0, 0, 0, 0.4)' : 'none'
                        }}
                    >
                        {t("landingPages.faq.category1")}
                    </MainButton>
                    <MainButton
                        variant={activeFaq === FaqTypes.JOBS ? buttonVariants.LIGHT_BLUE : buttonVariants.TEXT}
                        rounded={true}
                        size='xmedium'
                        action={() => handleFaqTypeClick(FaqTypes.JOBS)}
                        sx={{
                            textShadow: activeFaq === FaqTypes.JOBS ? '0 1px 2px rgba(0, 0, 0, 0.4)' : 'none'
                        }}
                    >
                        {t("landingPages.faq.category2")}
                    </MainButton>
                    <MainButton
                        variant={activeFaq === FaqTypes.OTHERS ? buttonVariants.LIGHT_BLUE : buttonVariants.TEXT}
                        rounded={true}
                        size='xmedium'
                        action={() => handleFaqTypeClick(FaqTypes.OTHERS)}
                        sx={{
                            textShadow: activeFaq === FaqTypes.OTHERS ? '0 1px 2px rgba(0, 0, 0, 0.4)' : 'none'
                        }}
                    >
                        {t("landingPages.faq.category3")}
                    </MainButton>
                </div>
                <div className={styles.dataContainer}>
                    {selectedData.map((data, index) => (
                        <Accordion 
                            key={index}
                            expanded={expandedAccordion === index}
                            onChange={handleAccordionChange(index)}
                            sx={{ 
                                boxShadow: 'none',
                                padding: 0,
                                '& .MuiAccordionSummary-root .MuiTypography-root': {
                                    fontSize: '22px',
                                    padding: '15px 0px',
                                    color: colors.DARK_BLUE,
                                    fontWeight: 500
                                },
                                '& .MuiAccordionSummary-root .Mui-expanded': {
                                    margin: '0'
                                },
                                '& .MuiCollapse-vertical .MuiTypography-root': {
                                    fontWeight: 300
                                }
                            }}
                        >
                            <AccordionSummary
                                expandIcon={<ArrowDropDownIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography component="span">{data.question}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    <span dangerouslySetInnerHTML={{ __html: data.answer}}></span>
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>
            </div>
        </div>
    )
}
